var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFixed(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 42,
    viewBox: "0 0 62 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_153542",
    x: 0,
    y: 0,
    width: 62,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104700",
    "data-name": "Group 104700",
    transform: "translate(-12767 -1004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78914",
    "data-name": "Group 78914",
    transform: "translate(12775.513 1007)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.51, -3)",
    filter: "url(#Rectangle_153542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_153542-2",
    "data-name": "Rectangle 153542",
    transform: "translate(9 6)",
    fill: "rgba(255,255,255,0)",
    stroke: "#828282",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 24,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 42.5,
    height: 22.5,
    rx: 2.25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_64244",
    "data-name": "Path 64244",
    d: "M6.426,8.429V21.516H38.413",
    fill: "none",
    stroke: "#828282",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    transform: "translate(3.487 6)",
    fill: "#828282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.792900085449219 2.5 L 1.207100033760071 2.5 L 3 0.707099974155426 L 4.792900085449219 2.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 1.414219975471497 L 2.414220094680786 2 L 3.585779905319214 2 L 3 1.414219975471497 M 3 0 L 6 3 L 0 3 L 3 0 Z",
    stroke: "none",
    fill: "#828282"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_12",
    "data-name": "Polygon 12",
    transform: "translate(40.987 18.5) rotate(90)",
    fill: "#828282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.792900085449219 2.5 L 1.207100033760071 2.5 L 3 0.707099974155426 L 4.792900085449219 2.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 1.414219975471497 L 2.414220094680786 2 L 3.585779905319214 2 L 3 1.414219975471497 M 3 0 L 6 3 L 0 3 L 3 0 Z",
    stroke: "none",
    fill: "#828282"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixed);
export default __webpack_public_path__ + "static/media/Fixed.78e26870e1cc35ea1ac50fe4e2390b1b.svg";
export { ForwardRef as ReactComponent };